<template>
  <div id="app">
    <Face/>
    <div>
      <h1><a href="https://www.github.com/SamWheating" color="#2c3e50">Sam Wheating</a></h1>
      <h3>Computer Engineer.</h3>
    </div>
    <div id="test-area">
        <b-nav align='center' tabs :small="use_small">
          <b-nav-item><div v-on:click="page = 'about'">About</div></b-nav-item>
          <b-nav-item><div v-on:click="page = 'stats'">Stats</div></b-nav-item>
          <b-nav-item v-if=False ><div v-on:click="page = 'resume'">Resume</div></b-nav-item>
          <b-nav-item><div v-on:click="page = 'contact'">Contact</div></b-nav-item>
        </b-nav>
    </div><br>
    <HelloWorld v-show="page === 'about'"/>
    <Stats v-show="page === 'stats'"/>
    <Contact v-show="page === 'contact'"/>
    <Resume v-show="page === 'resume'"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Stats from './components/Stats.vue'
import Contact from './components/Contact.vue'
import Resume from './components/Resume.vue'
import Face from './components/face/Face.vue'

export default {
  name: 'app',
  components: {
    HelloWorld,
    Stats,
    Contact,
    Resume,
    Face
  },

  data: function () {
    return {
      page: 'about',
    }
  },

  computed: {
    use_small: function () {
      return screen.width < 400
    }
  }

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10% ;
}

#app a {
  text-decoration: none; 
  color: #1a237e;

}

p {
  margin-left: 5%;
  margin-right: 5%;
}

li {
  display: inline-block;
  margin: 0 0px;
  text-align: center;
}

#app h3 {
  margin-bottom: 2%
}

#app h1 {
  margin-left: 5%;  
  margin-right: 5%;
}

</style>
